import { StaticImageData } from 'next/image';

import { LEGACY_PRODUCTS } from 'constants/products';

import singlePouchImage from './assets/single-pouch.png';
import doublePouchImage from './assets/double-pouch.png';
import singleTravelPacksImage from './assets/single-travel-packs.png';
import doubleTravelPacksImage from './assets/double-travel-packs.png';

interface ProductData {
  name: string;
  image: StaticImageData;
}

const singlePouch: ProductData = {
  name: 'AG1 Single Pouch',
  image: singlePouchImage
};

const doublePouch: ProductData = {
  name: 'AG1 Double Pouch',
  image: doublePouchImage
};

const singleTravelPacks: ProductData = {
  name: 'AG1 Single Travel Packs',
  image: singleTravelPacksImage
};

const doubleTravelPacks = {
  name: 'AG1 Double Travel Packs',
  image: doubleTravelPacksImage
};

export const productsData = (() => {
  const result: Record<number, ProductData> = {};

  Object.entries(LEGACY_PRODUCTS).forEach(([key, value]) => {
    Object.values(value).forEach((item) => {
      result[item.oneTime] = key === 'ultimate-daily' ? singlePouch : singleTravelPacks;
      result[item.subscription] = key === 'ultimate-daily' ? singlePouch : singleTravelPacks;
      result[item.subscriptionDouble] = key === 'ultimate-daily' ? doublePouch : doubleTravelPacks;
    });
  });

  return result;
})();

export const CHECKOUT_TYPE = {
  key: 'checkoutType',
  BAB: 'BAB',
  SHOP: 'SHOP',
  PDP: 'PDP',
  PLP: 'PLP',
  EXPRESS_CHECKOUT: 'EXPRESS_CHECKOUT'
};
